import { apiSlice } from './apiSlice';
import { DAILYSTOCKS_URL } from '../constants';

export const dailyStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new dailyStock
    createDailyStock: builder.mutation({
      query: (dailyStock) => ({
        url: DAILYSTOCKS_URL,
        method: 'POST',
        body: dailyStock,
      }),
    }),
    // Get dailyStock details by ID
    getDailyStockDetails: builder.query({
      query: (id) => ({
        url: `${DAILYSTOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's dailyStocks
    getMyDailyStocks: builder.query({
      query: () => ({
        url: `${DAILYSTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all dailyStocks (Admin view)
    getDailyStocks: builder.query({
      query: () => ({
        url: DAILYSTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a dailyStock as delivered (Admin action)
    deliverDailyStock: builder.mutation({
      query: (dailyStockId) => ({
        url: `${DAILYSTOCKS_URL}/${dailyStockId}/deliver`,
        method: 'PUT',
      }),
    }),
    // Delete a dailyStock (Admin action)
    deleteDailyStock: builder.mutation({
      query: (dailyStockId) => ({
        url: `${DAILYSTOCKS_URL}/${dailyStockId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useCreateDailyStockMutation,
  useGetDailyStockDetailsQuery,
  useGetMyDailyStocksQuery,
  useGetDailyStocksQuery,
  useDeliverDailyStockMutation,
  useDeleteDailyStockMutation,
} = dailyStocksApiSlice;